<div class="modal-header">
    <h3 class="modal-title">Delete Category</h3>
</div>
<div class="modal-body">
    Are you sure you to DELETE this category?
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="deleteClicked()">Delete</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>